export const body1 = 14
export const body2 = 12
export const button = 14
export const label = 12
export const caption = 12
export const table = 12
